/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {CompileTokenMetadata} from './compile_metadata';
import {CompileReflector} from './compile_reflector';
import * as o from './output/output_ast';

const CORE = '@angular/core';

export class Identifiers {
  static ANALYZE_FOR_ENTRY_COMPONENTS: o.ExternalReference = {
    name: 'ANALYZE_FOR_ENTRY_COMPONENTS',
    moduleName: CORE,

  };
  static ElementRef: o.ExternalReference = {name: 'ElementRef', moduleName: CORE};
  static NgModuleRef: o.ExternalReference = {name: 'NgModuleRef', moduleName: CORE};
  static ViewContainerRef: o.ExternalReference = {name: 'ViewContainerRef', moduleName: CORE};
  static ChangeDetectorRef: o.ExternalReference = {
    name: 'ChangeDetectorRef',
    moduleName: CORE,

  };
  static QueryList: o.ExternalReference = {name: 'QueryList', moduleName: CORE};
  static TemplateRef: o.ExternalReference = {name: 'TemplateRef', moduleName: CORE};
  static Renderer2: o.ExternalReference = {name: 'Renderer2', moduleName: CORE};
  static CodegenComponentFactoryResolver: o.ExternalReference = {
    name: 'ÉµCodegenComponentFactoryResolver',
    moduleName: CORE,

  };
  static ComponentFactoryResolver: o.ExternalReference = {
    name: 'ComponentFactoryResolver',
    moduleName: CORE,

  };
  static ComponentFactory: o.ExternalReference = {name: 'ComponentFactory', moduleName: CORE};
  static ComponentRef: o.ExternalReference = {name: 'ComponentRef', moduleName: CORE};
  static NgModuleFactory: o.ExternalReference = {name: 'NgModuleFactory', moduleName: CORE};
  static createModuleFactory: o.ExternalReference = {
    name: 'Éµcmf',
    moduleName: CORE,

  };
  static moduleDef: o.ExternalReference = {
    name: 'Éµmod',
    moduleName: CORE,

  };
  static moduleProviderDef: o.ExternalReference = {
    name: 'Éµmpd',
    moduleName: CORE,

  };
  static RegisterModuleFactoryFn: o.ExternalReference = {
    name: 'ÉµregisterModuleFactory',
    moduleName: CORE,

  };
  static inject: o.ExternalReference = {name: 'ÉµÉµinject', moduleName: CORE};
  static directiveInject: o.ExternalReference = {name: 'ÉµÉµdirectiveInject', moduleName: CORE};
  static INJECTOR: o.ExternalReference = {name: 'INJECTOR', moduleName: CORE};
  static Injector: o.ExternalReference = {name: 'Injector', moduleName: CORE};
  static ÉµÉµdefineInjectable: o.ExternalReference = {name: 'ÉµÉµdefineInjectable', moduleName: CORE};
  static InjectableDef: o.ExternalReference = {name: 'ÉµÉµInjectableDef', moduleName: CORE};
  static ViewEncapsulation: o.ExternalReference = {
    name: 'ViewEncapsulation',
    moduleName: CORE,

  };
  static ChangeDetectionStrategy: o.ExternalReference = {
    name: 'ChangeDetectionStrategy',
    moduleName: CORE,

  };
  static SecurityContext: o.ExternalReference = {
    name: 'SecurityContext',
    moduleName: CORE,

  };
  static LOCALE_ID: o.ExternalReference = {name: 'LOCALE_ID', moduleName: CORE};
  static TRANSLATIONS_FORMAT: o.ExternalReference = {
    name: 'TRANSLATIONS_FORMAT',
    moduleName: CORE,

  };
  static inlineInterpolate: o.ExternalReference = {
    name: 'ÉµinlineInterpolate',
    moduleName: CORE,
  };
  static interpolate: o.ExternalReference = {name: 'Éµinterpolate', moduleName: CORE};
  static EMPTY_ARRAY: o.ExternalReference = {name: 'ÉµEMPTY_ARRAY', moduleName: CORE};
  static EMPTY_MAP: o.ExternalReference = {name: 'ÉµEMPTY_MAP', moduleName: CORE};
  static Renderer: o.ExternalReference = {name: 'Renderer', moduleName: CORE};
  static viewDef: o.ExternalReference = {name: 'Éµvid', moduleName: CORE};
  static elementDef: o.ExternalReference = {name: 'Éµeld', moduleName: CORE};
  static anchorDef: o.ExternalReference = {name: 'Éµand', moduleName: CORE};
  static textDef: o.ExternalReference = {name: 'Éµted', moduleName: CORE};
  static directiveDef: o.ExternalReference = {name: 'Éµdid', moduleName: CORE};
  static providerDef: o.ExternalReference = {name: 'Éµprd', moduleName: CORE};
  static queryDef: o.ExternalReference = {name: 'Éµqud', moduleName: CORE};
  static pureArrayDef: o.ExternalReference = {name: 'Éµpad', moduleName: CORE};
  static pureObjectDef: o.ExternalReference = {name: 'Éµpod', moduleName: CORE};
  static purePipeDef: o.ExternalReference = {name: 'Éµppd', moduleName: CORE};
  static pipeDef: o.ExternalReference = {name: 'Éµpid', moduleName: CORE};
  static nodeValue: o.ExternalReference = {name: 'Éµnov', moduleName: CORE};
  static ngContentDef: o.ExternalReference = {name: 'Éµncd', moduleName: CORE};
  static unwrapValue: o.ExternalReference = {name: 'Éµunv', moduleName: CORE};
  static createRendererType2: o.ExternalReference = {name: 'Éµcrt', moduleName: CORE};
  // type only
  static RendererType2: o.ExternalReference = {
    name: 'RendererType2',
    moduleName: CORE,

  };
  // type only
  static ViewDefinition: o.ExternalReference = {
    name: 'ÉµViewDefinition',
    moduleName: CORE,
  };
  static createComponentFactory: o.ExternalReference = {name: 'Éµccf', moduleName: CORE};
  static setClassMetadata: o.ExternalReference = {name: 'ÉµsetClassMetadata', moduleName: CORE};
}

export function createTokenForReference(reference: any): CompileTokenMetadata {
  return {identifier: {reference: reference}};
}

export function createTokenForExternalReference(
    reflector: CompileReflector, reference: o.ExternalReference): CompileTokenMetadata {
  return createTokenForReference(reflector.resolveExternalReference(reference));
}
